<div class="d-flex justify-content-end p-2">
  <button mat-mini-fab color="white" (click)="close(true)">
    <mat-icon class="text-danger">close</mat-icon>
  </button>
</div>
<app-pdf-viewer-url
  [base64Src$]="document"
  [filenameForDownload]="documentName"
></app-pdf-viewer-url>
